export default "__VITE_ASSET__CErYND7G__"